import React from 'react';
import Link from 'react-router/Link';
import Dialog from 'material-ui/Dialog';
import FlatButton from 'material-ui/FlatButton';

const Welcome = (props) => {
  const imgStyle = {
    verticalAlign: 'middle',
  };
  const actions = [
    <FlatButton
      label="Close"
      primary
      onTouchTap={props.handleClose}
    />];


  let customMessage = '';

  if (props.auth.user.hasGroup) {
    customMessage = <span>You are currently in group { props.auth.user.group.name }.</span>;
  }

  if (props.auth.user.onTrial || props.auth.user.onGenericTrial) {
    customMessage = <span>You are currently on your trial period. After that you need to get a subscription to access Pronounce Live - subscriptions are coming soon!</span>;
  }

  if (!props.auth.user.onTrial && props.auth.user.hasActiveSubscription) {
    customMessage = <span>Your subscription is currently valid. The subscription will be automatically renewed when it ends unless you cancel it beforehand.</span>;
  }

  return (
    <Dialog
      actions={actions}
      modal={false}
      open={props.open}
      onRequestClose={props.handleClose}
      autoScrollBodyContent
    >
      <h3>Welcome to Pronounce Live!</h3>
      <p>
            The easiest way to get started is to simply paste or type text in the text field and select a language for the text.
      </p>
      <p><img alt="Pronounce Live example" src="/images/welcome-example.png" /></p>
      <p>You are then ready for your first pronunciation exercise. </p>
      <p><img alt="Listen" style={imgStyle} src="/images/welcome-listen.png" /> Listen to the model pronunciation</p>
      <p><img alt="Record" style={imgStyle} src="/images/welcome-record.png" /> Repeat after the model</p>
      <p><img alt="Play" style={imgStyle} src="/images/welcome-play-your-take.png" /> Review your performance</p>
      <p>Close this window to start!</p>

      <p>{customMessage}</p>

    </Dialog>
      );
};

export default Welcome;



// WEBPACK FOOTER //
// ./src/components/Welcome.js